import type { JSX } from 'react';

import { PreSelectionUser } from '@/modules/materialityAssessment/types/user';

import { EnhancedEsgCategory, OpenDataRequest } from './gql/graphql';

export interface CompanyFormInput {
  name: string;
  headquarter: string;
  industryId?: number;
  subIndustryId: number;
  employeesNum: string;
}

export interface Tab {
  input: JSX.Element;
  label: string;
  index: number;
  id: string;
}

export interface Stats {
  title: string;
  value: number;
  unit: string;
  progress?: number;
  development?: number;
  infoText?: string;
}

export type TranslatedOpenDataRequest = OpenDataRequest & {
  translatedStatus: string;
  translatedEsgCategory: string;
  locationName: string;
};

export interface StakeholdersResultsModalType {
  isOpen: boolean;
  type?: StakeholderVoteResult;
  data?: PreSelectionUser[];
}

export type TranslatedCategoryType = EnhancedEsgCategory & {
  translatedTitle: string;
};

export enum StakeholderVoteResult {
  FAVOUR = 'favour',
  AGAINST = 'against',
}
